
function initSlideCases() {
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll('[data-slide-cases]');

  sections.forEach(sectionEl => {
    const slider = sectionEl.querySelector('.slider');
    const slideContents = sectionEl.querySelectorAll('.slide-text_content');
    const slideCaption = sectionEl.querySelectorAll('.slider-caption');
    const navItems = Array.from(sectionEl.querySelectorAll('.nav-item'));
    const slides = Array.from(sectionEl.querySelectorAll('.slide')); 

    if (!slider || slides.length === 0) return;
    const itemScale   = window.innerWidth >= 750 ? 0.5 : 0.6;
    const endSlider   = window.innerWidth >= 750 ? "top 30%" : "top 50%";
    const endContent  = window.innerWidth >= 750 ? "top 37%" : "top 10%";
    const startSlider = window.innerWidth >= 750 ? "top 70%" : "top 90%";

    gsap.fromTo(slider,
      { scale: itemScale, borderRadius: '20px', rotate: 5 },
      {
        scale: 1,
        borderRadius: '0px',
        rotate: 0,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slider,
          start: startSlider,
          end: endSlider,
          scrub: true
        }
      }
    );

    gsap.fromTo(slideCaption,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slider,
          start: "top 60%",
          end: endContent,
          scrub: true
        },
        stagger: 0.2
      }
    );

    gsap.fromTo(slideContents,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slider,
          start: "top 60%",
          end: endContent,
          scrub: true
        },
        stagger: 0.2
      }
    );

    const currentIndexRef = { current: 0 };
    const isTweeningRef = { current: false };
    const transitionDuration = 1000;
    const autoSlideInterval = 5000;

    slides.forEach((slide, index) => {
      slide.style.opacity = index === 0 ? '1' : '0';
      slide.style.zIndex = index === 0 ? '2' : '1';
      slide.style.transition = `opacity ${transitionDuration}ms ease`;
    });

    function updateNav(activeIndex) {
      navItems.forEach((item, index) => {
        const bar = item.querySelector('.nav-bar');
        if (index === activeIndex) {
          item.classList.add('active');
          if (bar) bar.style.opacity = '1';
        } else {
          item.classList.remove('active');
          if (bar) bar.style.opacity = '0.5';
        }
      });
    }

    function gotoSlide(nextIndex) {
      if (isTweeningRef.current || nextIndex === currentIndexRef.current) return;
      isTweeningRef.current = true;

      const currentSlide = slides[currentIndexRef.current];
      const nextSlide = slides[nextIndex];

      nextSlide.style.zIndex = '2';
      currentSlide.style.zIndex = '1';

      nextSlide.style.opacity = '1';
      currentSlide.style.opacity = '0';

      updateNav(nextIndex);

      setTimeout(() => {
        currentIndexRef.current = nextIndex;
        isTweeningRef.current = false;
      }, transitionDuration);
    }

    updateNav(0);

    navItems.forEach((item, index) => {
      item.addEventListener('click', () => gotoSlide(index));
    });

    setInterval(() => {
      const nextIndex = (currentIndexRef.current + 1) % slides.length;
      gotoSlide(nextIndex);
    }, autoSlideInterval);
  });
}

document.addEventListener('DOMContentLoaded', initSlideCases);


document.addEventListener('shopify:section:load', initSlideCases);
document.addEventListener('shopify:section:unload', initSlideCases);

